const tournamentStatuses = {
  created: {
    id: 1,
    name: 'Новый'
  },
  registration: {
    id: 2,
    name: 'Регистрация открыта'
  },
  confirmation: {
    id: 3,
    name: 'Регистрация завершена'
  },
  in_progress: {
    id: 4,
    name: 'Идет'
  },
  finished: {
    id: 5,
    name: 'Закончен'
  },
  registration_closed: {
    id: 6,
    name: 'Регистрация закрыта'
  }
};

export default tournamentStatuses;



// WEBPACK FOOTER //
// ./src/components/tournamentStatuses.js